module.exports = __webpack_public_path__ + "media/images/chat_candidate_closed_account-1a3ea50f504e555b6f7512ec28c1145e.svg";